import ErrorState from '@component/ErrorState';

const NotFoundPage = () => {
  return <ErrorState type={ErrorState.type.pageNotFound} />;
};

export default NotFoundPage;
